import React from "react";
import classNames from "classnames/bind";
import styles from "./Tracing.module.css";
import SideBarManagerAI from "./Sidebar/SideBarPlayBack";
import { TracingEventContext } from "../../../contexts";
import { useEffect, useState } from "react";
import VideoAI from "./VideoAI";
import { Loading, Toast } from "../../../components";
import { getListServices } from "../../../services/api/aiConfigService";
import InProcessBuild from "../../../components/InProcessBuild";
const cx = classNames.bind(styles);
function Tracing() {
  const [cameraCode, setCameraCode] = useState();
  const [name, setName] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [url, setUrl] = useState("");
  const [listTabBar, setListTabBar] = useState();
  const [tabActive, setTabActive] = useState(0);
  const [codeService, setCodeService] = useState();
  const [listCodeCamera, setListCodeCamera] = useState([]);
  const [listCheckApi, setListCheckApi] = useState([]);
  const [codeAi, setCodeAi] = useState("All");
  const [isShow, setIsShow] = useState(false);
  const [isApply, setIsApply] = React.useState(false);
  const [hourStart, setHourStart] = useState();
  const [hourEnd, setHourEnd] = useState();
  const [timeStart, setTimeStart] = useState(new Date());
  const [timeEnd, setTimeEnd] = useState(new Date());
  const [isVideoAI, setIsVideoAI] = useState(1)
  useEffect(() => {
    const getListService = async () => {
      setIsLoading(true);
      try {
        const res = await getListServices.get();
        const listTabBar = res.map((item, index) => {
          return {
            tabIndex: index,
            tabName: item.SUBJECT_NAME,
            code: item.CODE,
          };
        });
        setListTabBar(listTabBar);
        setCodeService(listTabBar[0].CODE);
        setIsLoading(false);
      } catch (error) {
        Toast.open("Không thể tải xuống danh sách dịch vụ");
        setIsLoading(false);
      }
    };
    getListService();
  }, []);
  useEffect(() => {
    const checkService = async () => {
      try {
        // console.log(listCodeCamera);
        const data = listCodeCamera.map((item) => item?.code);
        const res = await getListServices.checkServiceCamera(
          data,
          timeStart,
          timeEnd,
          hourStart,
          hourEnd,
          codeAi
        );
        setListCheckApi(res.data);
      } catch (e) {

      }
    };
    if (!isApply) {
      checkService();
    }
  }, [isApply, hourEnd, hourStart, timeEnd, timeStart, codeAi, listCodeCamera]);
  const handleChangeTabActive = (code) => {
    setCodeAi(code);
  };

  let value = {
    cameraCode,
    setCameraCode,
    name,
    setName,
    codeService,
    listCodeCamera,
    setListCodeCamera,
    codeAi,
    setCodeAi,
    isShow,
    setIsShow,
    url,
    setUrl,
    isApply,
    setIsApply,
    hourStart,
    setHourStart,
    hourEnd,
    setHourEnd,
    timeStart,
    setTimeStart,
    timeEnd,
    setTimeEnd,
    listCheckApi,
    setListCheckApi,
    isVideoAI,
    setIsVideoAI
  };
  return (
    <TracingEventContext.Provider value={value}>
      <div id="__notification"></div>
      <div className={cx("container")}>
        <div className={cx("slider")}>
          <SideBarManagerAI isVideoAI={isVideoAI} />
        </div>
        {!isLoading ? (
          <div className={cx("content")}>
            <div className={cx("header")}>
              <h1 className={cx("title")}>Truy vết sự kiện</h1>
              <div className={cx("title")}>{name}</div>
            </div>
            <VideoAI
              listTabBar={listTabBar}
              tabActive={tabActive}
              getTabActive={handleChangeTabActive}
            />
          </div>
        ) : (
          <div className={cx("behavior")}>
            <Loading />
          </div>
        )}
      </div>
      {/* <InProcessBuild /> */}
    </TracingEventContext.Provider>
  );
}

export default Tracing;
